import { SET_DOCKET_ATTRIBUTE } from 'vx/mutations'

export default {
  computed: {
    file: {
      get () {
        if (this.docket.file) {
          return this.docket.file.name
        }

        return this.docket.photo_name
      },

      set (value) {
        this[SET_DOCKET_ATTRIBUTE]({ ...this.identifiers, attribute: 'file', value })
        this[SET_DOCKET_ATTRIBUTE]({ ...this.identifiers, attribute: 'photo_name', value: value && value.name })
      }
    },

    name: {
      get () {
        return this.docket.file_name
      },

      set (value) {
        this[SET_DOCKET_ATTRIBUTE]({ ...this.identifiers, attribute: 'file_name', value })
      }
    },

    number: {
      get () {
        return this.docket.number
      },

      set (value) {
        this[SET_DOCKET_ATTRIBUTE]({ ...this.identifiers, attribute: 'number', value })
      }
    },

    weight: {
      get () {
        return this.docket.weight
      },

      set (value) {
        this[SET_DOCKET_ATTRIBUTE]({ ...this.identifiers, attribute: 'weight', value })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/weighbridge/docket-state-mapper.js